import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import Chart from "react-apexcharts";

/* ================= STAT CARD ================= */
const StatCard = ({ title, value, color, icon }) => (
  <Card className={`stat-card ${color} h-100`}>
    <CardBody className="d-flex align-items-start">
      <div className="w-100 d-flex justify-content-between">
        {/* LEFT CONTENT */}
        <div>
          {/* NUMBER – top */}
          <h2 className="fw-bold text-white mb-4">
            {value ?? 0}
          </h2>

          {/* TEXT – down */}
          <span className="fw-bold text-white d-block">
            {title}
          </span>
        </div>

        {/* ICON */}
        <i className={`bi ${icon} stat-icon fs-1 text-white`} />
      </div>
    </CardBody>
  </Card>
);


/* ================= APEX LINE GRAPH ================= */
const MiniLineGraph = ({ title, total, value, color }) => {
  const chartConfig = {
    series: [
      {
        name: "Total Calls",
        data: [0, total],
      },
      {
        name: title,
        data: [0, value],
      },
    ],
    options: {
      chart: {
        type: "area",
        toolbar: { show: false },
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#adb5bd", color],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.4,
          opacityTo: 0.1,
        },
      },
      grid: {
        strokeDashArray: 4,
      },
      xaxis: {
        categories: ["Start", "Today"],
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
      },
      legend: {
        position: "top",
      },
    },
  };

  return (
    <Card className="h-100">
      <CardBody>
        <h6 className="mb-3">{title}</h6>
        <Chart
          options={chartConfig.options}
          series={chartConfig.series}
          type="area"
          height={260}
        />
      </CardBody>
    </Card>
  );
};

/* ================= MAIN COMPONENT ================= */
const CallCountCards = ({ data }) => {
  return (
    <>
      {/* ===== CARDS ===== */}
      <Row className="g-3">
        <Col xl="4" md="6">
          <StatCard
            title="Total Calls Today"
            value={data.total_calls_today}
            color="bg-info"
            icon="bi-telephone"
          />
        </Col>

        <Col xl="4" md="6">
          <StatCard
            title="Connected Calls Today"
            value={data.connected_calls_today}
            color="bg-success"
            icon="bi-telephone-inbound"
          />
        </Col>

        <Col xl="4" md="6">
          <StatCard
            title="Disconnected Calls Today"
            value={data.disconnected_calls_today}
            color="bg-danger"
            icon="bi-telephone-x"
          />
        </Col>

        <Col xl="4" md="6">
          <StatCard
            title="Promise To Pay Today"
            value={data.promise_to_pay_today}
            color="bg-warning"
            icon="bi-cash-stack"
          />
        </Col>

        <Col xl="4" md="6">
          <StatCard
            title="Paid Calls Today"
            value={data.paid_calls_today}
            color="bg-primary"
            icon="bi-check-circle"
          />
        </Col>

        <Col xl="4" md="6">
          <StatCard
            title="Total Calls Till Today"
            value={data.total_calls_till_today}
            color="bg-dark"
            icon="bi-bar-chart-line"
          />
        </Col>
      </Row>

      {/* ===== GRAPHS (ONE LINE, TWO GRAPHS) ===== */}
      <Row className="mt-4 g-3">
        <Col md="6">
          <MiniLineGraph
            title="Connected Calls"
            total={data.total_calls_today}
            value={data.connected_calls_today}
            color="#198754"
          />
        </Col>

        <Col md="6">
          <MiniLineGraph
            title="Disconnected Calls"
            total={data.total_calls_today}
            value={data.disconnected_calls_today}
            color="#dc3545"
          />
        </Col>
      </Row>
    </>
  );
};

export default CallCountCards;

